import { Modal, Form, Radio, Button, Divider, notification } from "antd";
import axiosInstance from "../../../utils/axios";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../../context/LoaderContext";
import { useContext } from "react";
import GlobalContext from "../../../context/GlobalContext";
import { useTranslation } from "react-i18next";

const ModalModifications = (props) => {
  const { openModalModifications, setOpenModalModifications, affaire_id } =
    props;
  const { form } = useContext(GlobalContext);
  const { setSurveyJson, setIsLoading, setSurveyData } = useLoader();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleFinish = (values) => {
    if (
      values?.type1 === "non" &&
      values?.type2 === "non" &&
      values?.type3 === "non"
    ) {
      setIsLoading(false);
      setOpenModalModifications(false);
      notification.error({
        message: t("Erreur"),
        description: t(
          "Vous devrez sélectionner au moins un type de modification."
        ),
        duration: 0,
      });
      return;
    }
    setIsLoading(true);
    axiosInstance
      .get(
        `${import.meta.env.VITE_APP_GEOPROD_API}/admin-bpm/contrat/${
          import.meta.env.VITE_APP_LIGNE_PRODUIT_REPRISE
        }`,
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      )
      .then((response) => {
        if (
          values?.type1 === "oui" &&
          values.type2 === "oui" &&
          values.type3 === "oui"
        ) {
          sessionStorage.setItem(
            "surveyJson",
            JSON.stringify(response?.data?.contrat?.form)
          );
          setSurveyJson(response?.data?.contrat?.form);
        } else {
          const formJson = response?.data?.contrat?.form;
          if (values?.type1 === "non") {
            formJson.pages = formJson.pages.filter((e) => e.name !== "page0");
          }
          if (values?.type2 === "non") {
            formJson.pages = formJson.pages.filter(
              (e) =>
                e.name !== "Données de Directeur de l’Établissement" &&
                // e.name !== "page4" &&
                e.name !== "page5" &&
                e.name !== "page6" &&
                e.name !== "page7"
            );
          }
          if (values?.type3 === "non") {
            formJson.pages = formJson.pages.filter((e) => e.name !== "page8");
          }
          if (values?.type1 === "non" && values?.type3 === "non") {
            formJson.pages = formJson.pages.filter((e) => e.name !== "page2");
          }
          if (values?.type1 === "non" && values?.type2 === "non") {
            formJson.pages = formJson.pages.filter((e) => e.name !== "page4");
          }
          if (values?.type1 === "oui" && values?.type2 === "non") {
            formJson.pages = formJson.pages.map((page) => {
              if (page.name === "page4") {
                return {
                  ...page,
                  visible: false,
                };
              }
              return page;
            });
          }
          sessionStorage.setItem("surveyJson", JSON.stringify(formJson));
          setSurveyJson(formJson);
        }

        axiosInstance
          .get(
            import.meta.env.VITE_APP_GEOPROD_API +
              "/get_info_specifique/" +
              affaire_id,
            {
              headers: {
                Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
                  ?.Acces_Token,
              },
            }
          )
          .then((res) => {
            setSurveyData(res?.data);
            // debugger;
            const data_for_comparison = {
              establishment_data_address:
                res?.data?.response?.data.establishment_data_address,
              establishment_data_training_type:
                res?.data?.response?.data.establishment_data_training_type,
            };

            const trainer_and_training_data = {
              trainer_data: res?.data?.response?.data?.trainer_data,
              training_nature_data:
                res?.data?.response?.data?.training_nature_data,
            };

            sessionStorage.setItem(
              "data_for_comparison",
              JSON.stringify(data_for_comparison)
            );
            sessionStorage.setItem(
              "trainer_and_training_data",
              JSON.stringify(trainer_and_training_data)
            );
            const selectedOption =
              values?.type3 === "oui" &&
              values?.type2 === "non" &&
              values?.type1 === "non"
                ? "sans_bo_sans_validation"
                : values?.type1 === "oui"
                ? "avec_bo_validation"
                : "sans_bo_avec_validation";
            sessionStorage.setItem("selectedOption", selectedOption);
            navigate("/etablissements/edit", {
              state: {
                typeDeModification: "reprise",
                id_affaire: affaire_id,
                ligne_produit: import.meta.env.VITE_APP_LIGNE_PRODUIT_REPRISE,
                selectedOption: selectedOption,
                type1: values?.type1 === "oui",
                type2: values?.type2 === "oui",
                type3: values?.type3 === "oui",
              },
            });
            sessionStorage.setItem("reprise", true);
            setIsLoading(false);
            sessionStorage.removeItem("demande");
            sessionStorage.removeItem("consulter");
            form.resetFields();
          })
          .catch((error) => {
            setIsLoading(false);
            notification.error({
              message: "Erreur",
              description:
                "Une erreur s'est produite lors de la récupération des informations spécifiques.",
              duration: 0,
            });
          });
      });
  };

  return (
    <Modal
      title="Confirmation des modifications"
      open={openModalModifications}
      onCancel={() => setOpenModalModifications(false)}
      footer={null}
      centered
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        style={{ marginTop: "1rem" }}
      >
        <Divider orientation="left">
          Veuillez confirmer les informations suivantes :
        </Divider>

        <Form.Item
          label={
            <span style={{ fontWeight: 500 }}>
              Avez-vous des modifications de type 1 ?
            </span>
          }
          name="type1"
          rules={[
            { required: true, message: "Veuillez sélectionner une option" },
          ]}
        >
          <Radio.Group style={{ display: "flex", gap: "1rem" }}>
            <Radio.Button value="oui">Oui</Radio.Button>
            <Radio.Button value="non">Non</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label={
            <span style={{ fontWeight: 500 }}>
              Avez-vous des modifications de type 2 ?
            </span>
          }
          name="type2"
          rules={[
            { required: true, message: "Veuillez sélectionner une option" },
          ]}
        >
          <Radio.Group style={{ display: "flex", gap: "1rem" }}>
            <Radio.Button value="oui">Oui</Radio.Button>
            <Radio.Button value="non">Non</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label={
            <span style={{ fontWeight: 500 }}>
              Avez-vous des modifications de type 3 ?
            </span>
          }
          name="type3"
          rules={[
            { required: true, message: "Veuillez sélectionner une option" },
          ]}
        >
          <Radio.Group style={{ display: "flex", gap: "1rem" }}>
            <Radio.Button value="oui">Oui</Radio.Button>
            <Radio.Button value="non">Non</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Divider />

        <div style={{ textAlign: "right" }}>
          <Button
            onClick={() => setOpenModalModifications(false)}
            style={{ marginRight: 8 }}
          >
            Annuler
          </Button>
          <Button type="primary" htmlType="submit">
            Confirmer
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalModifications;
